import React from "react";
import { Output } from "valibot";

import { ChatUserInputValue } from "shared/api";
import {
  VariablesEventDetailSchema,
  VariablesRecordSchema,
} from "shared/schemas";

export const updateVariablesHelper = (
  variables:
    | Output<typeof VariablesRecordSchema>
    | Output<typeof VariablesEventDetailSchema>,
  setVariables: React.Dispatch<
    React.SetStateAction<Output<typeof VariablesRecordSchema>>
  >,
) => {
  setVariables(prevVariables =>
    Object.entries(variables).reduce((prev, [key, value]) => {
      if (typeof value === "object" && "value" in value) {
        return {
          ...prev,
          [key]: {
            key,
            value: String(value.value),
            fallback: value?.fallback || prevVariables[key]?.fallback || "",
          },
        };
      }
      return {
        ...prev,
        [key]: {
          key,
          value: String(value),
          fallback: prevVariables[key]?.fallback || "",
        },
      };
    }, prevVariables),
  );
};

export const updateVariablesViaFormData = (
  formData: ChatUserInputValue[],
  setVariables: React.Dispatch<
    React.SetStateAction<Output<typeof VariablesRecordSchema>>
  >,
) => {
  setVariables(state => {
    const copiedState = { ...state };
    for (const { key, value } of formData) {
      copiedState[key] = {
        key,
        value: value || copiedState[key]?.value || "",
        fallback: copiedState[key]?.fallback || "",
      };
    }
    return copiedState;
  });
};
